import { useState } from 'react';
import hicon from '../../images/icon/magic.svg'
import { Fade } from "react-awesome-reveal";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem
} from 'reactstrap';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq pb-140">
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms"><img
                                src={hicon} alt="" />FAQ’s</div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">Perguntas Frequentes</h2>
                        </div>
                    </Fade>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="xb-faq wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                            <Accordion open={open} toggle={toggle} className='accordion_box clearfix list-unstyled'>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="1" className='acc-btn'><span className="number">01</span> _ O que é a Synapz e como ela pode ajudar minha empresa?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1" className='acc_body'>
                                        <div className="content">
                                            <p>A Synapz é uma consultoria especializada na implantação de inteligência artificial prática e acessível. Oferecemos agentes de IA personalizados para atendimento ao cliente, automação de processos, criação de conteúdo, vendas, análise de dados e muito mais — tudo com foco em gerar resultados reais.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="2" className='acc-btn'><span className="number">02</span> _ A Synapz desenvolve agentes de atendimento via WhatsApp com inteligência artificial?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="2" className='acc_body'>
                                        <div className="content">
                                            <p>Sim. Criamos agentes inteligentes que atendem seus clientes automaticamente via WhatsApp, com linguagem natural, integração com sistemas e capacidade de resolver dúvidas, abrir chamados e muito mais.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="3" className='acc-btn'><span className="number">03</span> _ O que é o Synapz Chat?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="3" className='acc_body'>
                                        <div className="content">
                                            <p>O Synapz Chat é uma solução omnichannel que centraliza o atendimento de canais como WhatsApp, Instagram, Facebook, e-mail e site em um único painel. Você pode atender todos os canais com ou sem IA, com histórico completo de conversas e integração com sua operação.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="4" className='acc-btn'><span className="number">04</span> _ Posso automatizar o atendimento no meu site e e-mail com IA?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="4" className='acc_body'>
                                        <div className="content">
                                            <p>Sim! Nossos agentes de IA também atendem diretamente em seu site e e-mail, respondendo perguntas frequentes, captando leads e direcionando clientes para o setor certo, 24 horas por dia.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="5" className='acc-btn'><span className="number">05</span> _ Os agentes de inteligência artificial da Synapz se integram com meus sistemas?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="5" className='acc_body'>
                                        <div className="content">
                                            <p>Sim. Nossos agentes são integráveis via API, webhook ou conectores com plataformas como CRMs, ERPs, sistemas de marketing, bancos de dados, e ferramentas de atendimento.</p>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default FaqSection;
